import { connect, ConnectedProps } from 'react-redux'
import { CloseLateralModalSimple, ModalFullCentered } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'
import TableCustomers from '../../../../../../../../specificComponents/Customers/TableCustomersB2C'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../utils/reducers/company/employees'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'

type CustomersB2CListingModalProps = ReduxTableCustomers & ModalEditComponentProps & {}

const CustomersB2CListingModal: React.FC<CustomersB2CListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableCustomersConnect setTableInstance={() => { }} userPermissions={getUserPermissions('customer.profile.main') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const tableCustomersDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

type ReduxTableCustomers = ConnectedProps<typeof tableCustomersConnect>
const mapTableCustomersConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const tableCustomersConnect = connect(mapTableCustomersConnector, tableCustomersDispatch)
const tableCustomersLoading = withLoading(TableCustomers, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableCustomersConnect = tableCustomersConnect(tableCustomersLoading)

export default CustomersB2CListingModal